import { z } from 'zod';

import { FromSchema } from '@40seas/entities/common';
import { BaseEntity, BaseEntityFieldsArray, BaseEntitySchema } from '@40seas/models';
import { Seller } from '@40seas/entities/sellers';

export const SegmentSchema = z
    .object({
        tenantId: z.string(),
        buyer: z.string().optional(),
    })
    .strict();

export class Segment extends FromSchema(SegmentSchema) {
    tenantId: string;
    buyer?: string;
}

export const SegmentEntitySchema = BaseEntitySchema.extend({
    segments: z.array(SegmentSchema).optional(),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const WithBaseEntitySchema = <T extends { merge: (a: unknown) => T; strict: (message?: any) => any }>(schema: T): T =>
// schema.merge(BaseEntitySchema);
export const WithSegmentBaseEntitySchema = (schema: any): any => schema.merge(SegmentEntitySchema);

export interface SegmentEntity extends BaseEntity {
    buyer: string;
    tenantId: string;
    seller?: string | Seller;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export const SegmentEntityFieldsArray: (keyof BaseEntity | 'segments')[] = [...BaseEntityFieldsArray, 'segments'];
